import axios from "axios";

const axiosInstance = axios.create({
  //  baseURL: "http://192.168.0.66:8097/", // Your base URL
  // baseURL: "http://127.0.0.1:8089/", // Your base URL
  // baseURL: "http://117.205.68.9/apmccashback/", // Your base URL
  //  baseURL: "http://192.168.0.66:8097/", // Your base URL
   baseURL: "https://mwbtech.in/Loyality/", // Your base URL
  // baseURL: "/apmccashback/",
});

export default axiosInstance;